import { parseDateTime } from 'utils/dates/date.utils';
import {
  getWaveAndWindSegmentEntries,
  getWaveAndWindWeekdayEntries,
} from '../../../features/WaveAndWind/utils/waveAndWind.utils';
import {
  displayMarineValue,
  displayMarineValueWithUnit,
  hasMarineValue,
} from '../../../utils/marineForecast.utils';
import { getMarineWidgetLayout } from '../../../utils/marineForecastWidget.utils';

export const getWaveAndWindWidgetLayout = getMarineWidgetLayout;

export const getWaveAndWindWidgetDays = (marineEntries = []) => {
  const daysByNameMap = new Map();

  marineEntries.forEach((entry, index) => {
    if (!entry?.weekday) return;

    const timestamp = parseDateTime(entry?.iso8601)?.getTime();
    const sortValue = Number.isFinite(timestamp) ? timestamp : Number.MAX_SAFE_INTEGER;
    const currentDay = daysByNameMap.get(entry.weekday);

    if (!currentDay || sortValue < currentDay.sortValue) {
      daysByNameMap.set(entry.weekday, {
        weekday: entry.weekday,
        sortValue,
        sourceIndex: index,
      });
    }
  });

  return Array.from(daysByNameMap.values())
    .sort(
      (firstDay, secondDay) =>
        firstDay.sortValue - secondDay.sortValue || firstDay.sourceIndex - secondDay.sourceIndex,
    )
    .map(({ weekday }) => weekday);
};

export const getWaveAndWindWidgetSegmentEntries = (marineEntries, selectedDay) =>
  getWaveAndWindSegmentEntries(getWaveAndWindWeekdayEntries(marineEntries, selectedDay)).filter(
    Boolean,
  );

export const getWaveAndWindWidgetTileValue = (entry) =>
  displayMarineValueWithUnit(entry?.wave_height, ' ft');

export const getWaveAndWindWidgetTileAriaLabel = (entry) => {
  const segment = displayMarineValue(entry?.day_segment, 'selected period');
  const waveHeight = hasMarineValue(entry?.wave_height)
    ? `${entry.wave_height} feet`
    : 'wave height unavailable';
  const wind = [entry?.wind_speed, entry?.wind_short].filter(hasMarineValue).join(' ');

  return `Select ${segment} marine forecast, ${waveHeight}, wind ${wind || 'unavailable'}`;
};
